import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, FormControl, FormGroup } from 'modules/common/components';
import { AuthBox, Links } from '../styles';
import { FormWrapper, FormColumn } from 'modules/common/styles/main';
import { ControlLabel } from 'react-bootstrap';
import { Alert } from 'modules/common/utils';
import APIManager from 'modules/common/apiManager';
import { withRouter } from 'react-router';
import { localStore } from 'helpers';

const propTypes = {
  SignUp: PropTypes.func.isRequired
};

class SignUp extends Component {
  constructor(props) {
    super(props);

    this.mAPI = new APIManager();
    this.renderFormGroup = this.renderFormGroup.bind(this);

    this.state = {
      name: '',
      email: '',
      password: '',
      country_code: '',
      mobile_number: ''
    };
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  apiResponse(errorCode, data) {
    if (errorCode === 200) {
      Alert.success(`${data.message}`);
    } else {
      Alert.error(`${data}`);
    }
  }

  saveData(e) {
    let _this = this;
    e.preventDefault();
    let tData = {
      email: this.state.email,
      password: this.state.password,
      name: this.state.name,
      country_code: this.state.country_code,
      mobile_number: this.state.mobile_number
    };
    // this.mAPI.sendPostAPI(
    //   `auth/signup`,
    //   tData,
    //   data => {
    //     console.log(JSON.stringify(data, null, 2));
    //     let token = data.token;
    //     let user = data.user.email;
    //     console.log('data.user', user);
    //     localStorage.setItem('token', token);
    //     localStorage.setItem('email', user);
    //     // try {
    //     //   localStore.setItem('token', token);
    //     // } catch (e) {
    //     //   console.log(e);
    //     // }
    //     // try {
    //     //   localStore.setItem('user', JSON.stringify(user));
    //     // } catch (e) {
    //     //   console.log(e);
    //     // }
    //     if (data) {
    //       // window.location.href = '/otp';
    //       this.props.history.push('/otp');
    //       console.log('Successfull');
    //     }
    //     // window.location.href = '/otp';
    //   },
    //   (errorCode, data) => {
    //     console.log('data', data);
    //     this.apiResponse(errorCode, data);
    //   },
    //   `public`
    // );
  }

  render() {
    const { __ } = this.context;
    return (
      <AuthBox>
        <div>
          {/* <h2 style={{ marginBottom: '20px' }}>{__('Sign Up')}</h2> */}
          <form onSubmit={e => this.saveData(e)}>
            <FormWrapper>
              {/* <FormColumn></FormColumn> */}
              <FormColumn>
                {this.renderFormGroup('Name', {
                  defaultValue: '',
                  placeholder: 'William Baker',
                  autoFocus: true,
                  required: true,
                  id: 'name',
                  value: this.state.name,
                  onChange: e => {
                    this.setState({ name: e.target.value });
                  }
                })}
              </FormColumn>
              <FormColumn>
                {this.renderFormGroup('Email', {
                  defaultValue: '',
                  placeholder: 'your@email.com',
                  autoFocus: true,
                  required: true,
                  id: 'email',
                  value: this.state.email,
                  onChange: e => {
                    this.setState({ email: e.target.value });
                  }
                })}
              </FormColumn>
            </FormWrapper>
            <FormWrapper>
              <FormColumn>
                {this.renderFormGroup('Password', {
                  placeholder: '********',
                  defaultValue: '',
                  autoFocus: true,
                  required: true,
                  type: 'password',
                  value: this.state.password,
                  onChange: e => {
                    this.setState({ password: e.target.value });
                  },
                  id: 'password'
                })}
              </FormColumn>
            </FormWrapper>
            <FormWrapper>
              <FormColumn>
                {this.renderFormGroup('Country Code', {
                  defaultValue: '',
                  autoFocus: true,
                  required: true,
                  type: 'country_code',
                  value: this.state.country_code,
                  onChange: e => {
                    this.setState({ country_code: e.target.value });
                  },
                  id: 'country_code'
                })}
              </FormColumn>
              <FormColumn>
                {this.renderFormGroup('Mobile Number', {
                  defaultValue: '',
                  autoFocus: true,
                  required: true,
                  type: 'mobile_number',
                  value: this.state.mobile_number,
                  onChange: e => {
                    this.setState({ mobile_number: e.target.value });
                  },
                  id: 'mobile_number'
                })}
              </FormColumn>
            </FormWrapper>
            {/* <div>
              <Button
                btnStyle="default"
                type="submit"
                block
                style={{ marginTop: '30px' }}
              >
                SIGN UP
              </Button>
              <Links style={{ marginTop: '15px', textAlign: 'center' }}>
                Already have an account ?{' '}
                <Link to="/sign-in">{__('Login here')}</Link>
              </Links>
            </div> */}
            <div>
              {/* <Button
              btnStyle="default"
              type="submit"
              // block
              style={{ marginTop: '30px', border: '1px solid #C7C7C7' }}
            >
              Sign In
            </Button> */}
              <Button
                btnStyle="default"
                type="submit"
                block
                style={{ marginTop: '30px' }}
              >
                Sign Up
              </Button>
              <div className="line">
                <span> Or sign up with</span>
              </div>
              <Button
                btnStyle="simple"
                type="submit"
                block
                style={{
                  marginTop: '30px',
                  background: '#FAFAFA',
                  border: '1px solid #EDE7F6'
                }}
              >
                <img
                  src="images/Google.png"
                  style={{ width: '24px', height: 'auto' }}
                />{' '}
                Sign In with Google
              </Button>
              {/* <Links style={{ marginTop: '-12px', textAlign: 'end' }}>
              <Link to="/otp">{__('Comfirm Email')}</Link>
            </Links> */}
            </div>
          </form>
        </div>
      </AuthBox>
    );
  }
}

SignUp.propTypes = propTypes;
SignUp.contextTypes = {
  __: PropTypes.func
};

export default withRouter(SignUp);



// WEBPACK FOOTER //
// ./src/modules/auth/components/SignUp.js